export const apiUrl = process.env.REACT_APP_API_URL 
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID 
